export default function (instance) {
    return {
        getServices(params = null){
            return instance.get('service', params)
        },
        getService(params){
            return instance.get('service', params)
        },
        addService(params){
            return instance.postForm('service', params)
        },
    }
}